module.exports = __webpack_public_path__ + "static/media/image_part_003.770bd479.jpg";